import React from 'react'
import {Link} from 'react-router'
import {urls} from 'lib/urls'
import styles from './ProfileCard.scss'
import {ProfileImg} from 'common/ProfileImg'
import {AccountTypeBadge} from 'common/AccountTypeBadge'

export const ProfileCard = ({user}) => {
  const topStyle = {
    background: user.profileImageColor
  }

  return (
    <div className={styles.ProfileCard}>
      <div className={styles.top} style={topStyle}>
        {user.highlightedPhotoId !== 0 &&
          <div
            className={styles.topBgImg}
            style={{background: `url(${urls.photos.profile(user.highlightedPhotoId)}) center/cover`}} />}
        <Link to={`/users/${user.id}`}>
          <ProfileImg
            large
            user={user}
            className={styles.profileImg} />
        </Link>
      </div>
      <div className={styles.bottom}>
        <h2>{user.name} <AccountTypeBadge accountLevel={user.accountLevel} size={14} /></h2>
        {user.locality && <div className={styles.userLoc}>
          {user.locality}
          {user.adminArea && `, ${user.adminArea}`}
        </div>}
        {user.description && <div className={styles.userDesc}>
          {user.description}
        </div>}
        <a data-card-link href='/settings/account' className={styles.manageAccount}>Edit Profile</a>
      </div>
    </div>
  )
}
